/* co-native-scroll-motion.js */
/* Browser-owned transforms for simple scroll scenes. Interactive chapter state stays in JS. */
(function(w){
 'use strict';
 if(w.CONativeScrollMotion)return;
 function create({subject,items,range,inset='0px',reduced}){
  let animations=[],failed=false,dead=false,lastRange='';
  function clear(){animations.forEach(animation=>animation.cancel());animations=[];lastRange='';}
  function refresh(){
   if(dead)return false;
   if(reduced.matches){clear();return false;}
   if(failed||!subject||!items.length||typeof w.ViewTimeline!=='function'||!w.CSS?.supports('animation-range-start','cover 1px')||!items.every(item=>typeof item.element?.animate==='function'))return false;
   try{
    const [start,end]=range(),key=start+':'+end;
    if(animations.length){
     if(key!==lastRange)for(const animation of animations){animation.rangeStart=start;animation.rangeEnd=end;}
    }else{
     const timeline=new w.ViewTimeline({subject,axis:'block',inset});
     for(const {element,keyframes} of items){
      const animation=element.animate(keyframes,{timeline,rangeStart:start,rangeEnd:end,duration:'auto',fill:'both',easing:'linear'});
      animations.push(animation);
      if(animation.timeline!==timeline||animation.rangeStart===undefined||animation.rangeEnd===undefined)throw new Error('Incomplete view timeline support');
     }
    }
    lastRange=key;return true;
   }catch{failed=true;clear();return false;}
  }
  return {get active(){return animations.length>0;},refresh,destroy(){dead=true;clear();}};
 }
 function packageMotion(section,photo,markers,reduced){
  const ease='cubic-bezier(.333333,1,.666667,1)';
  const items=[{element:photo,keyframes:[{translate:'0 20px',easing:ease},{translate:'0 0px'}]},...markers.map((marker,i)=>{
   const start=i*.055,end=start+.62;
   return {element:marker.querySelector('.kit-pin-surface'),keyframes:[{translate:'0 12px',offset:0},{translate:'0 12px',offset:start,easing:ease},{translate:'0 0px',offset:end},{translate:'0 0px',offset:1}]};
  })];
  const motion=create({subject:photo,items,inset:'0px 6%',range:()=>['cover 0px','cover '+w.innerHeight*.66+'px'],reduced});
  return {get active(){return motion.active;},refresh(){
   if(!motion.refresh())return false;
   section.style.removeProperty('--kit-photo-y');markers.forEach(marker=>marker.style.removeProperty('--kit-pin-y'));return true;
  },destroy:()=>motion.destroy()};
 }
 w.CONativeScrollMotion={create,packageMotion};
})(window);

;
/* co-scroll-visibility.js */
/* Share one viewport observer and one passive scroll listener across nearby scenes.
   No geometry reads here: the browser reports proximity, controllers batch their frames. */
(function(w){
  'use strict';
  if(w.COScrollVisibility)return;
  const doc=w.document,jobs=new Set(),active=new Set(),targets=new Map();
  let listening=false;
  const observer=typeof w.IntersectionObserver==='function'?new w.IntersectionObserver(entries=>{
    const changed=new Set();
    for(const entry of entries){
      const users=targets.get(entry.target);if(!users)continue;
      for(const job of users){
        if(entry.isIntersecting)job.near.add(entry.target);else job.near.delete(entry.target);
        changed.add(job);
      }
    }
    for(const job of changed)sync(job,true);
    listen();
  },{rootMargin:'250px 0px',threshold:0}):null;
  function tick(){for(const job of active)job.schedule();}
  function listen(){
    const next=active.size>0&&!doc.hidden;
    if(next===listening)return;listening=next;
    if(next)w.addEventListener('scroll',tick,{passive:true});else w.removeEventListener('scroll',tick);
  }
  function sync(job,notify){
    const next=!doc.hidden&&job.near.size>0;
    if(next)active.add(job);else active.delete(job);
    if(!next)job.cancel?.();
    if(notify&&next)job.schedule();
  }
  function visibility(){for(const job of jobs)sync(job,!doc.hidden);listen();}
  function bind(elements,schedule,options={}){
    const nodes=[...new Set((Array.isArray(elements)?elements:[elements]).filter(Boolean))];
    const job={schedule,cancel:options.cancel,near:new Set(observer?[]:nodes)};
    if(!jobs.size)doc.addEventListener('visibilitychange',visibility);
    jobs.add(job);
    for(const node of nodes){
      if(!targets.has(node)){targets.set(node,new Set());observer?.observe(node);}
      targets.get(node).add(job);
    }
    sync(job,false);listen();
    let dead=false;
    function dispose(){
      if(dead)return;dead=true;job.cancel?.();active.delete(job);jobs.delete(job);
      for(const node of nodes){const users=targets.get(node);users.delete(job);if(!users.size){observer?.unobserve(node);targets.delete(node);}}
      job.near.clear();listen();
      if(!jobs.size)doc.removeEventListener('visibilitychange',visibility);
    }
    dispose.near=node=>job.near.has(node);
    return dispose;
  }
  w.COScrollVisibility={bind};
})(window);

;
/* co-app-wall-motion.js */
/* Scroll-linked app columns: one visible tile, one frame, no settling loop. */
(function(w,d){
 'use strict';
 if(w.COAppWallMotion)return;
 const mounted=new WeakMap(),clamp=n=>Math.max(0,Math.min(1,n));
 function init(wall,rail){
  if(!wall||!rail)return()=>{};
  mounted.get(wall)?.();
  const columns=[...wall.querySelectorAll('.co-app-wall-column')],reduced=w.matchMedia('(prefers-reduced-motion: reduce)');
  const originals=columns.map(el=>[el.style.transform,el.style.willChange]);
  let dead=false,visible=typeof w.IntersectionObserver!=='function',listening=false,frame=0,last=null;
  function write(shift){
   // Quantise to a fraction of a CSS pixel; unchanged frames do no DOM writes.
   const value=Math.round(shift*4)/4;
   if(value===last)return;last=value;
   for(const column of columns)column.style.transform='translate3d(0,'+(-value)+'px,0)';
  }
  function paint(){
   frame=0;if(dead||!listening)return;
   // Read geometry together before writing. Measuring the actual tile also
   // handles layout shifts, sticky ancestors and horizontal carousel swipes.
   const r=wall.getBoundingClientRect(),rr=rail.getBoundingClientRect();
   if(!r.height||r.bottom<=0||r.top>=w.innerHeight||r.right<=0||r.left>=w.innerWidth||r.right<=rr.left||r.left>=rr.right)return;
   const left=Math.max(0,rr.left),right=Math.min(w.innerWidth,rr.right);
   write(12+clamp((w.innerHeight-r.top)/(w.innerHeight+r.height))*240+clamp((right-r.left)/(Math.max(0,right-left)+r.width))*180);
  }
  function schedule(){if(listening&&!dead&&!frame)frame=w.requestAnimationFrame(paint);}
  function sync(){
   const active=!dead&&visible&&!d.hidden&&!reduced.matches;
   if(active!==listening){
    listening=active;
    for(const target of [w,rail])target[active?'addEventListener':'removeEventListener']('scroll',schedule,{passive:true});
    for(const column of columns)column.style.willChange=active?'transform':'';
   }
   if(!active){w.cancelAnimationFrame(frame);frame=0;}
   if(reduced.matches)write(12);else schedule();
  }
  const observer=typeof w.IntersectionObserver==='function'?new w.IntersectionObserver(entries=>{
   if(dead)return;visible=entries[entries.length-1].isIntersecting;sync();
  }):null;
  const resize=typeof w.ResizeObserver==='function'?new w.ResizeObserver(schedule):null;
  observer?.observe(wall);resize?.observe(wall);resize?.observe(rail);
  w.addEventListener('resize',schedule,{passive:true});
  d.addEventListener('visibilitychange',sync);reduced.addEventListener?.('change',sync);
  function destroy(){
   if(dead)return;dead=true;sync();observer?.disconnect();resize?.disconnect();
   w.removeEventListener('resize',schedule);d.removeEventListener('visibilitychange',sync);reduced.removeEventListener?.('change',sync);
   columns.forEach((el,i)=>{el.style.transform=originals[i][0];el.style.willChange=originals[i][1];});
   mounted.delete(wall);
  }
  mounted.set(wall,destroy);sync();return destroy;
 }
 w.COAppWallMotion={init};
})(window,document);
